import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=9d8eb458&scoped=true&"
import script from "./footer.ts?vue&type=script&lang=ts&"
export * from "./footer.ts?vue&type=script&lang=ts&"
import style0 from "./footer.scss?vue&type=style&index=0&id=9d8eb458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8eb458",
  null
  
)

component.options.__file = "footer.vue"
export default component.exports